// ** Auth Endpoints
const defaultConfig = {
  tokenType: "Bearer",
  storageTokenKeyName: "token",
  storageRefreshTokenKeyName: "refreshToken",
  loginEndpoint: "/Account",
};
export default defaultConfig;
